<template>
  <div class="info-tooltip">
    <div class="row">
      <p v-if="isMin && !isReadOnly" class="info-text">Mín:<br /><strong>{{ value }}</strong></p>
      <p v-if="!isMin && !isReadOnly" class="info-text">Máx:<br /><strong>{{ value }}</strong></p>
      <p v-if="isReadOnly" class="info-text">Min: <strong>{{ min }}</strong> -  Máx: <strong>{{ max }}</strong></p>
      <p class="info-text"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MinMaxToolTip',
  props: ['isMin', 'value', 'isReadOnly', 'min', 'max'],
}
</script>
